<script setup lang="ts">
import { ref } from 'vue';
import PaymentMethodCard from './PaymentMethodCard.vue';
import { posStore } from '../../../../stores/posStore';
import { PaymentReceipts, PaymentType } from '../../../../types/models';
import { formatNumber } from '../../../../utils/CommonFunctions';
import MessageBox from '../../../../services/MessageBox';
import FileUpload from '../../../../components/ui/form/FileUpload.vue';
import TextInput from '../../../../components/ui/form/TextInput.vue';

const pos = posStore();

const payment_methods_id = ref<number | string | null>(null);
const paymentMethod = ref<PaymentType | null>(null);
function selectPaymentMethod(method: any) {
  payment_methods_id.value = method.id;
  paymentMethod.value = method;
  console.log(method);
  if (!method.require_reference && !method.require_attachment && !method.check_credit) {
    AddPayment(method);
  }
  if (method.check_credit) {

    console.log(pos.selectedPosInvoice?.invoice.customer?.available_credit);
    if (Number(pos.selectedPosInvoice?.invoice.customer?.available_credit ?? 0) > 0) {
      AddPayment(method);
    }
  }
}


const hanldeOcrRead = (reference: string, _amount: string, file: string) => {
  if (reference) currentReference.value = reference;
  if (file) currentAttachment.value = file;
  if (paymentMethod.value)
    AddPayment(paymentMethod.value);
};

const currentReference = ref("");
const currentAttachment = ref("");
const AddPayment = (method: PaymentType) => {
  if (!method) return;
  if (!pos.net_total || pos.net_total <= 0) return;

  
  if (method.require_reference && !currentReference.value) {
    MessageBox.show("Reference is required", "warning");
    return;
  }

  if (method.require_attachment && !currentAttachment.value) {
    MessageBox.show("Attachment is required", "warning");
    return;
  }

  let pay: PaymentReceipts = {
    id: "",
    date_time: new Date().toISOString().split("T")[0],
    prefix: "",
    suffix: "",
    ref_no: "",
    payment_types_id: method.id,
    payment_type: method,
    currencys_id:  1, //TODO: Make Dynamic later
    currency: "",
    exchange_rate: 1,
    amount: pos.net_total,
    tendered: pos.net_total,
    change: 0,
    outlets_id: pos.selectedPosInvoice?.invoice.outlets_id ?? '',
    outlet_pos_stations_id: '',
    cashier_dutys_id: '', //TODO: Get Cashier Duty
    customers_id: "",
    shift_end_reports_id: "",
    attachment: currentAttachment.value,
    reference: currentReference.value,
    status_id: "",
    users_id: "",
    uid: "",
  };

  let paymt = [];
  paymt.push(pay);
  if (pos.selectedPosInvoice && pos.selectedPosInvoice.invoice) {
    pos.selectedPosInvoice.invoice.payments = paymt;
  }
  
  payment_methods_id.value = method.id;
};

</script>

<template>
  <div class="sales-step">
    <div class="p-4 h-full overflow-y-auto pb-20">
      <!-- Order Summary -->
      <div class="card mb-4">
        <h3 class="font-medium text-neutral-900 mb-3">Order Summary</h3>
        
        <div class="flex justify-between mb-2">
          <span class="text-neutral-600">Subtotal</span>
          <span class="text-neutral-900">{{ formatNumber(pos.sub_total) }}</span>
        </div>
        
        <div class="flex justify-between mb-2">
          <span class="text-neutral-600">Tax</span>
          <span class="text-neutral-900">{{ formatNumber(pos.tax_amount) }}</span>
        </div>
        
        <div class="flex justify-between font-semibold">
          <span class="text-neutral-800">Total</span>
          <span class="text-primary-600">{{ formatNumber(pos.net_total) }}</span>
        </div>
      </div>
      
      <!-- Payment Methods -->
      <h2 class="text-lg font-semibold text-neutral-900 mb-3">Select Payment Method</h2>
      
      <PaymentMethodCard
        v-for="method in pos.payment_types"
        :key="method.id"
        :method="method"
        :selected="payment_methods_id === method.id"
        @select="selectPaymentMethod"
      />

      <div
        v-if="paymentMethod?.check_credit"
        class="mb-4 flex items-center gap-2 text-sm text-blue-700"
      >
        <span>Available Credit:</span>
        <span class="font-semibold">
          {{ formatNumber(pos.selectedPosInvoice?.invoice.customer?.available_credit ?? 0) }}
        </span>
      </div>


      <div class="mb-6" v-if="paymentMethod?.require_reference || paymentMethod?.require_attachment">
          <div class="flex gap-2">
            <div class="flex-1">
              <FileUpload
                label=""
                placeholder="Attachment"
                path="payment_receipts"
                ref="attachment"
                v-model="currentAttachment"
                v-if="paymentMethod?.require_attachment"
                :ocr="paymentMethod?.read_ocr"
                :ocr-length="paymentMethod?.ocr_string_length"
                :ocr-match="paymentMethod?.ocr_init_string"
                :currency="'MVR'"
                @ocrRead="hanldeOcrRead"
              />
              <TextInput
                label=""
                placeholder="Reference"
                ref="reference"
                v-model="currentReference"
                v-if="paymentMethod?.require_reference"
              />
            </div>
          </div>
        </div>

    </div>
  </div>
</template>